export default __webpack_public_path__ + "static/media/our-partner-logo-17.39e7370c.jpeg";